module.exports = __webpack_public_path__ + "blue-wave.svg?1dc2b50ac139381929b65d1ae2c26877";